import React from 'react'

import { Box, Grid, Paper } from '@mui/material'
import { endOfDay, startOfMonth } from 'date-fns'

import { CardTitle } from 'components/common/controls'
import { ReportFileType, ReportFileTypeValues } from 'constants/EntityConstants'
import { MyIncomeReportInputDtoInput, useGetMyIncomeReportQuery } from 'generated/graphql'
import { GetFileName, SaveFile, ShowRestError } from 'helpers'
import { DownloadMyIncomeReport } from 'services/RestClient'

import { ReportTable } from '../common'
import FilterCriteria from './FilterCriteria'

const defaultFilter = {
  start: startOfMonth(new Date()),
  end: endOfDay(new Date()),
  customerIds: [],
  reasonCodes: [],
}

const MyIncome = () => {
  const [isProcessing, setIsProcessing] = React.useState(false)
  const [filter, setFilter] = React.useState<MyIncomeReportInputDtoInput>(defaultFilter)

  const { data: customerIncomeReportData, fetchMore } = useGetMyIncomeReportQuery({
    variables: { input: filter },
  })

  React.useEffect(() => {
    fetchMore({ variables: { input: filter } })
  }, [filter, fetchMore])

  const headerRow = React.useMemo(
    () => customerIncomeReportData?.myIncomeReport.rows[0],
    [customerIncomeReportData],
  )

  const bodyRows = React.useMemo(
    () =>
      customerIncomeReportData?.myIncomeReport.rows.filter((_, index) => {
        if (index !== 0) {
          return true
        }
      }),
    [customerIncomeReportData],
  )

  const handleViewReport = (filter: MyIncomeReportInputDtoInput) => {
    setFilter(filter)
  }

  const handleDownloadReport = (type: ReportFileType, filter: MyIncomeReportInputDtoInput) => {
    setIsProcessing(true)

    DownloadMyIncomeReport(type, filter)
      .then((response) => {
        setIsProcessing(false)

        let fileName = GetFileName(response)
        if (!fileName) {
          const format = ReportFileTypeValues.find((reportType) => reportType.id === type)?.name
          fileName = `my-income-report.${format}`
        }

        SaveFile(response.data, fileName)
      })
      .catch((error) => {
        ShowRestError(error)
      })
      .finally(() => {
        setIsProcessing(false)
      })
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper variant='outlined'>
          <Box p={2}>
            <CardTitle>Filter Criteria</CardTitle>
            <FilterCriteria
              defaultFilter={defaultFilter}
              isProcessing={isProcessing}
              onViewReport={handleViewReport}
              onDownloadReport={handleDownloadReport}
            />
          </Box>
        </Paper>
      </Grid>

      <Grid item xs={12}>
        <Paper variant='outlined'>
          <Box p={2}>
            <CardTitle>Report Table</CardTitle>
            <ReportTable headerRow={headerRow} bodyRows={bodyRows} />
          </Box>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default MyIncome
